exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-title {\n  top: 50%;\n  right: 0;\n  color: #4a4a4a;\n  margin-top: -10px;\n  position: absolute; }\n  .status-title span {\n    font-weight: bold; }\n  .status-title.connected span {\n    color: #2CA01C; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/QbTabs/components/scss/statusTitle.scss
// module id = 930
// module chunks = 1